export default "__VITE_ASSET__BqWoszfN__"